import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Vant from 'vant'
import { Locale } from 'vant';
import 'vant/lib/index.css'
import ja_JP from 'vant/lib/locale/lang/ja-JP';
Locale.use('ja_JP', ja_JP);

createApp(App).use(store).use(router).use(Vant).mount('#app');

